const timeRangeTypes = {
  exactDateRange: 'exact_date_range',
  relativeDateRange: 'relative_date_range',
  // relativeMeasurementCount: 'relative_measurement_count', // WIP
};

export default {
  relativeOptions: [
    { value: 'minutes', text: 'Minute(s)', millis: 60 * 1000 },
    { value: 'hours', text: 'Hour(s)', millis: 1000 * 60 * 60 },
    { value: 'days', text: 'Day(s)', millis: 1000 * 60 * 60 * 24 },
    { value: 'months', text: 'Month(s)', millis: 1000 * 60 * 60 * 24 * 30 },
  ],

  time_range_type: timeRangeTypes,

  getEpochRange: function(selection) {
    switch (selection.type) {

      case timeRangeTypes.exactDateRange:
        if (!selection.options.epochStart || !selection.options.epochEnd) {
          throw new Error(`epochStart and epochEnd are required for exactDateRange`);
        }

        return {
          start: selection.options.epochStart,
          end: selection.options.epochEnd,
        };

      case timeRangeTypes.relativeDateRange:
        if (isNaN(selection.options.milliseconds)) {
          throw new Error(`milliseconds is required for relativeDateRange`);
        }

        return {
          start: new Date().getTime() - selection.options.milliseconds,
          end: new Date().getTime(),
        };

      default:
        throw new Error(`unknown time range type (${selection.type})`);
    }
  },
}